import { AxiosError } from 'axios';

import { HTTP_ERRORS } from 'services/api/ApiClientService/constants';

import { ErrorHandlerType, InitErrorHandlerType } from 'services/api/ApiClientService/types';

// onErrorHandler decorator
// Returns a function that takes an axios error params, expand params and add extra param with error info(status, code).
export const getErrorHandler = (onErrorHandler: InitErrorHandlerType): ErrorHandlerType => {
    return (error, config) => {
        const response = (error as AxiosError)?.response;
        const request = (error as AxiosError)?.request;
        const status = response?.status;

        const codeErrorMessage = HTTP_ERRORS[String(status)];
        const message = codeErrorMessage ? `${codeErrorMessage} - ${status}` : error.message;

        const extras: Record<string, unknown> = {
            requestURL: request?.responseURL,
            response: response,
            status,
            message,
        };

        onErrorHandler({ error, config, extras, message, status });
    };
};
